import { queryClient, trpc } from "~/utils/trpc";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { AppContent } from "./-apps/AppContent";
import { Dialog, DialogContent } from "@quake/shared-ui/components/ui/dialog";

export const Route = createFileRoute("/_dashboard/$datasetSlug/apps/$slug")({
  component: RouteComponent,
  loader: async ({ params }) => {
    const app = await queryClient.fetchQuery(trpc.apps.getAppBySlug.queryOptions({ slug: params.slug }));
    if (!app) throw new Error("App not found");
    return { app };
  },
});

function RouteComponent() {
  const { app } = Route.useLoaderData();
  const navigate = useNavigate();
  return (
    <Dialog
      key={app.id}
      defaultOpen
      onOpenChange={(open) => {
        if (!open) navigate({ to: `..` });
      }}
    >
      <DialogContent className="sm:max-w-[80vw] sm:max-h-[80vh] overflow-auto">
        <AppContent app={app} />
      </DialogContent>
    </Dialog>
  );
}
